export default __webpack_public_path__ + "static/media/rubik-v12-latin-900.edd7f89a.woff2";